export default "__VITE_ASSET__BGctjaAT__"